import { FormBanner } from 'shared/landingBuyer/components/FormBanner';
import { FormContainer } from '../FormContainer';

export const FormBannerContainer: React.FC = () => {
  return <FormBanner form={<FormContainer theme="white" title={'Не тратьте время — продайте с профи'} />} />;
};
